<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="130px" label-suffix="：" inline>
      <div>
        <el-form-item label="县区用户名称" prop="username">
          <el-input v-model="form.username" placeholder="请输入县区用户名称" v-trim/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="所属市局" prop="parentId">
          <el-select v-model="form.parentId" filterable placeholder="请选择所属市局" @change="selectSJ">
            <el-option
              v-for="item in sjList"
              :key="item.id"
              :value="item.id"
              :label="item.username"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div >
        <el-form-item label="所属区域" prop="areaId">
          <el-select v-model="form.areaId" placeholder="请选择区域">
            <el-option
              v-for="item in areas"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
          <!-- <div class="address-plus">
            <el-select v-model="form.provinceId" placeholder="请选择省份" @change="selectProvince">
              <el-option
                v-for="item in province()"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
            <el-select v-model="form.cityId" placeholder="请选择城市"  @change="selectCity">
              <el-option
                v-for="item in cities"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </div> -->
        </el-form-item>
      </div>
      <div>
        <el-form-item label="姓名" prop="realname">
          <el-input v-model="form.realname" placeholder="请输入姓名" v-trim/>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号" v-trim/>
        </el-form-item>
      </div>
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import { checkMobile, nameRule } from '@/utils/form'
import { fetchList as userList } from '@/api/business/account'
import { treeList } from '@/api/business/areas'
export default {
  name: 'OperaCompanyUserWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    const newRule = (rule, value, callback) => {
     if (!this.form.areaId) {
        callback(new Error('请先选择县区'))
      } else {
        callback()
      }
    }
    return {
      // 表单数据
      form: {
        id: null,
        realname: '',
        username: '',
        parentId: '',
        // provinceId: '',
        cityId: '',
        areaId: '',
        mobile: '',
        type: '7',
        password: '123456'
      },
      sjList: [],
      // 验证规则
      rules: {
        username: [
          { required: true, message: '请输入县区用户名称', trigger: 'blur' }
        ],
        realname: [
          { required: false, validator: nameRule, trigger: 'blur' }
        ],
        mobile: [
          { required: false, validator: checkMobile, trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请选择所属市局', trigger: 'change' }
        ],
        // cityId: [
        //   { required: true, validator: newRule, trigger: 'change' }
        // ],
        areaId: [
          { required: true, validator: newRule, trigger: 'change' }
        ]
      },
      cities: [],
      areas: []
    }
  },
  // inject: ['province'],
  created () {
    this.config({
      api: '/business/account',
      'field.id': 'id'
    })
    userList({
      capacity:999,
      model: { type: 8 }
    })
      .then(res => {
        this.sjList = res.records
      })
  },
  methods: {
    open (title, target, type, baseForm) {
      // debugger
      this.title = title
      this.visible = true
      this.type = type
      this.baseForm = baseForm
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }

      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        console.log(this.form);
        this.selectCity(this.form.cityId, true)
      })
    },
    // defaultCity () {
    //   if (this.form.provinceId != null) {
    //     const tempProvince = this.province().find(item => item.id === this.form.provinceId)
    //     if (tempProvince) {
    //       this.cities = tempProvince.childList
    //     }
    //   }
    //   if (this.form.cityId != null) {
    //     const tempCity = this.cities.find(item => item.id === this.form.cityId)
    //     if (tempCity) {
    //       this.areas = tempCity.childList
    //     }
    //   }
    // },
    // // 选择省份
    // selectProvince (val) {
    //   this.cities = []
    //   this.areas = []
    //   this.form.cityId = ''
    //   this.form.areaId = ''
    //   treeList({ type: 1, parentId: val })
    //     .then(res => {
    //       this.cities = res
    //     })
    //   // const tempProvince = this.province().find(item => item.id === val)
    //   // if (tempProvince) {
    //   //   this.cities = tempProvince.childList
    //   // }
    // },
    selectSJ(val) {
      const tempSJ = this.sjList.find(item => item.id === val)
      // debugger
      this.selectCity(tempSJ.cityId)
    },
    // 选择城市
    selectCity (cityId, isInit) {
      this.areas = []
      if (!isInit) {
        this.form.areaId = ''
      }
     
      treeList({ type: 2, parentId: cityId })
        .then(res => {
          this.areas = res
        })
    }
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
</style>
